import apiClient from "@/lib/api";

const BASE = "/admin/pilotage/ai-consumption";

export const getAiConsumptionSummary = () => apiClient.get(`${BASE}/summary`).then(({ data }) => data);
export const getAiConsumptionDaily = (params) => apiClient.get(`${BASE}/daily`, { params }).then(({ data }) => data);
export const getAiConsumptionMonthly = () => apiClient.get(`${BASE}/monthly`).then(({ data }) => data);
export const getAiConsumptionCalls = (params) => apiClient.get(`${BASE}/calls`, { params }).then(({ data }) => data);
export const getAiConsumptionCall = (id) => apiClient.get(`${BASE}/calls/${encodeURIComponent(id)}`).then(({ data }) => data);
export const exportAiConsumptionCsv = (params = {}) => apiClient.get(`${BASE}/export`, {
  params,
  responseType: "blob",
}).then(({ data }) => data);
